<template>
  <div class="question">
    <div class="text">{{ titleText }}</div>
    <div class="question-box">
      <img :src="'//cdn.original-fun.com/gugong/' + data.qImg + '.png'" />
    </div>
    <div class="answer-box">
      <div
        class="a"
        v-for="(item, index) in data.answerArr"
        :key="index"
        @click="choose(item, index)"
      >
        <img :src="'//cdn.original-fun.com/gugong/' + item.img + '.png'" />
        <div class="duigou" :class="{ 'show': index === selectedIndex }"></div>
      </div>
    </div>

    <HeadTip
      :data="data"
      v-if="right === false"
      @jump="$emit('jump', false)"
    ></HeadTip>
  </div>
</template>

<script>
//script
import Tools from '../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../scripts/Global';

//组件
import HeadTip from './headTip';

export default {
  props: ['data'],
  data() {
    return {
      titleText: this.data.qText,
      selectedIndex: undefined,
      selectedData: undefined,
      right: undefined,
    };
  },
  components: { HeadTip },
  created() {},
  computed: {},
  methods: {
    choose(item, index) {
      if (this.right === undefined) {
        this.selectedIndex = index;
        this.selectedData = item;

        this.right = !!this.selectedData.right;
        if (this.right) {
          this.$emit('jump', true);
        } else {
          this.titleText = this.data.errText;
        }
        this.$emit('finish', this.right);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.question {
  background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
  background-position: 0 90%;
  width: 7.5rem;
  height: 9rem;
  margin: 0 auto;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
  background-size: contain;
  top: 50%;
  margin-top: -5rem;
  font-size: 12px;

  .question-box {
    width: 5rem;
    height: 3rem;

    margin: 0.2rem auto 0 auto;
    img {
      width: 100%;
    }
  }

  .text {
    width: 4rem;
    // background: #ffffff54;
    margin: 2.2rem auto 0 auto;
    padding: 0.1rem 0.2rem 0.1rem 0.2rem;
    text-align: left;
    color: #6c5141;
    font-weight: bold;
  }

  .answer-box {
    width: 5rem;
    margin: 0 auto;
    padding: 0.3rem 0 0.3rem 0px;
    position: relative;
    overflow: hidden;

    .a {
      width: 1.6rem;
      height: 1.5rem;

      position: relative;
      float: left;
      img {
        width: 100%;
      }
    }
    .duigou {
      display: none;
      background-image: url(//cdn.original-fun.com/gugong/对勾.png);
      background-position: center;
      background-size: contain;
      width: 1rem;
      height: 1rem;
      background-repeat: no-repeat;
      position: absolute;
      bottom: 0;
      right: 0;
      &.show {
        display: block;
      }
    }

    .side-man {
      display: none;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 2rem;
      background: #4f8a0f;
      height: 4rem;
      .img {
        position: absolute;
        bottom: 0px;
        left: 0;
      }
    }
  }

  .button {
    background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
    position: absolute;
    width: 3rem;
    height: 1rem;
  }
}
</style>
